"use client";

import { c as _c } from "react/compiler-runtime";
import { api } from "@agroproj/backend/convex/_generated/api";
import { useMutation, useQuery } from "convex/react";
import type { Route } from "next";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button, ButtonLink } from "@/components/ui/button";
import { Section } from "@/components/ui/section";
export function AssistantInsights(t0) {
  const $ = _c(31);
  const {
    organizationSlug
  } = t0;
  const clock = useMutation(api.assistant.insights.clock);
  const dismiss = useMutation(api.assistant.insights.dismiss);
  const [clockError, setClockError] = useState(false);
  const [bucket, setBucket] = useState();
  let t1;
  if ($[0] !== clock) {
    t1 = () => {
      let active = true;
      const refresh = () => {
        if (document.visibilityState === "visible") {
          clock({}).then(value => {
            if (active) {
              setBucket(value);
              setClockError(false);
            }
          }).catch(() => {
            if (active) {
              setClockError(true);
            }
          });
        }
      };
      refresh();
      const timer = setInterval(refresh, 60000);
      window.addEventListener("focus", refresh);
      document.addEventListener("visibilitychange", refresh);
      return () => {
        active = false;
        clearInterval(timer);
        window.removeEventListener("focus", refresh);
        document.removeEventListener("visibilitychange", refresh);
      };
    };
    $[0] = clock;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== clock || $[3] !== organizationSlug) {
    t2 = [clock, organizationSlug];
    $[2] = clock;
    $[3] = organizationSlug;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== bucket || $[6] !== organizationSlug) {
    t3 = bucket === undefined ? "skip" : {
      organizationSlug,
      bucket
    };
    $[5] = bucket;
    $[6] = organizationSlug;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const result = useQuery(api.assistant.insights.list, t3);
  if (clockError) {
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Section title={"Pontos de aten\xE7\xE3o"}><p>Não foi possível atualizar os alertas. Tente novamente ao retornar à página.</p></Section>;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  if (!result) {
    return null;
  }
  let t4;
  if ($[9] !== result.coverage) {
    t4 = result.coverage.some(_temp);
    $[9] = result.coverage;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const limited = t4;
  const t5 = limited ? "Sele\xE7\xE3o parcial dos registros consultados." : "At\xE9 cinco alertas dos registros consultados.";
  let t6;
  if ($[11] !== result.observedAt || $[12] !== result.timezone) {
    t6 = new Intl.DateTimeFormat("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      timeZone: result.timezone
    }).format(result.observedAt);
    $[11] = result.observedAt;
    $[12] = result.timezone;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== result.timezone || $[15] !== t5 || $[16] !== t6) {
    t7 = <p className="text-muted-foreground text-xs/relaxed">{t5}{" "}Verificado às{" "}{t6}{" "}({result.timezone}).</p>;
    $[14] = result.timezone;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== dismiss || $[19] !== limited || $[20] !== organizationSlug || $[21] !== result.items) {
    t8 = result.items.length === 0 ? <p>Nenhum alerta encontrado{limited ? " nesta sele\xE7\xE3o" : ""}.</p> : <ul className="divide-y">{result.items.map(item => <li className="flex flex-wrap items-center justify-between gap-2 py-2" key={item.key}><p className="min-w-0 flex-1">{item.reason}</p><div className="flex gap-1"><ButtonLink href={item.path as Route} size="sm" variant="outline">Abrir</ButtonLink><Button size="sm" variant="ghost" onClick={() => {
            dismiss({
              organizationSlug,
              key: item.key,
              fingerprint: item.fingerprint
            }).catch(_temp2);
          }}>Ocultar por 7 dias</Button></div></li>)}</ul>;
    $[18] = dismiss;
    $[19] = limited;
    $[20] = organizationSlug;
    $[21] = result.items;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== result.coverage) {
    t9 = result.coverage.map(_temp3).join(" \xB7 ") || "Nenhum dom\xEDnio habilitado.";
    $[23] = result.coverage;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t9) {
    t10 = <p className="text-muted-foreground text-xs/relaxed">{t9}</p>;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t7 || $[29] !== t8) {
    t11 = <Section title={"Pontos de aten\xE7\xE3o"}>{t7}{t8}{t10}</Section>;
    $[27] = t10;
    $[28] = t7;
    $[29] = t8;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
}
function _temp3(scope_0) {
  return `${scope_0.domain === "projects" ? "Projetos" : scope_0.domain === "finance" ? "Financeiro" : "CRM"}: ${scope_0.scanned}${scope_0.limited ? " (leitura limitada)" : ""}`;
}
function _temp2() {
  return toast.error("N\xE3o foi poss\xEDvel ocultar o alerta.");
}
function _temp(scope) {
  return scope.limited;
}